import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

function UploadStatusPopup({ open, status, fileName }) {
    if (!open) return null;

    return (
        <Box
            sx={{
                width: 320,
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: 5,
                p: 2,
                zIndex: 3000,
            }}
        >
            <Box display="flex" alignItems="center" gap={1}>
                {status === "uploading" && (
                    <>
                        <CircularProgress size={18} />
                        <strong>Uploading...</strong>
                    </>
                )}

                {status === "success" && (
                    <>
                        <CheckCircleOutlineIcon color="success" />
                        <strong>File uploaded</strong>
                    </>
                )}

                {status === "error" && (
                    <>
                        <CancelIcon color="error" />
                        <strong>Upload failed</strong>
                    </>
                )}

                {status === "partial" && (
                    <>
                        <WarningAmberIcon color="warning" />
                        <strong>Some files failed to upload</strong>
                    </>
                )}
            </Box>

            <Box
                mt={1}
                title= {fileName}
                sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {fileName}
            </Box>
        </Box>
    );
}

export default UploadStatusPopup;